import React, { useCallback, useEffect, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

import { Column } from 'primereact/column';
import { toast } from 'react-toastify';
import { Container } from './styles';

import LabelSp from '../../components/LabelSp';

import InputCurrencySp from '../../components/InputCurrencySp';

import ModuloService from '../../services/ModuloService';
import DropdownSp from '../../components/DropdownSp';
import DataTableSp from '../../components/DataTableSp';
import BotaoMenuGrid from '../../components/BotaoMenuGrid';
import { SistemaEdicaoModuloModel } from '../../util/Models';
import EdicaoService from '../../services/EdicaoService';
import { formatFloat } from '../../util/functions';

function EdicaoSistema(props) {
  const edicaoModulosProp = props.sistemaEdicao?.sistemaEdicaoModulo;

  const { visible, handleConfirm, handleClose, viewMode, modoEdicao } = props;
  const [sistemaEdicao, setSistemaEdicao] = useState({ ...props.sistemaEdicao });
  const [modulo, setModulo] = useState();
  const [moduloTipoCobranca, setModuloTipoCobranca] = useState(1);
  const [modulos, setModulos] = useState([]);
  const [edicoes, setEdicoes] = useState([]);
  const [edicao, setEdicao] = useState();

  const [moduloPercentual, setModuloPercentual] = useState(0);
  const [moduloQtdAcessoIncluso, setModuloQtdAcessoIncluso] = useState(1);

  const [edicaoModulos, setEdicaoModulos] = useState(
    edicaoModulosProp ? [...edicaoModulosProp] : []
  );
  const [alterandoEdicaoModulo, setAlterandoEdicaoModulo] = useState(false);

  // useCalback
  const inserirEdicaoModulo = useCallback(() => {
    const idx = edicaoModulos.findIndex(m => m.idModulo === modulo.id);
    if (!alterandoEdicaoModulo && idx >= 0) {
      toast.warning('Módulo já existe');
      return;
    }
    let mod;
    if (idx >= 0) {
      mod = edicaoModulos[idx];
    } else {
      mod = new SistemaEdicaoModuloModel();
    }
    mod.idModulo = modulo.id;
    mod.modulo = { ...modulo };
    mod.percentual = moduloPercentual;
    mod.qtdAcessoIncluso = moduloQtdAcessoIncluso;
    mod.tipoCobranca = moduloTipoCobranca;
    if (idx < 0) {
      edicaoModulos.push(mod);
    }

    setEdicaoModulos([...edicaoModulos]);
    limparDadosModulo();
  }, [
    alterandoEdicaoModulo,
    edicaoModulos,
    modulo,
    moduloPercentual,
    moduloQtdAcessoIncluso,
    moduloTipoCobranca,
  ]);

  const loadModules = useCallback(async () => {
    const r = await ModuloService.findAll();

    const retorno = r.items.map(e => {
      return {
        label: e.descricao,
        value: e,
      };
    });
    setModulos(retorno);
  }, []);

  const loadEdicoes = useCallback(async () => {
    const r = await EdicaoService.findAll();

    const retorno = r.items.map(e => {
      return {
        label: e.nome,
        value: e,
      };
    });
    setEdicoes(retorno);

    if ((modoEdicao || viewMode) && props.sistemaEdicao?.edicao) {
      const exist = retorno.find(e => e.value.id === props.sistemaEdicao?.edicao.id);
      if (exist) {
        setEdicao(exist?.value);
      }
    }
  }, [modoEdicao, props.sistemaEdicao.edicao, viewMode]);

  useEffect(() => {
    loadModules();
    loadEdicoes();
  }, [loadEdicoes, loadModules]);

  const limparDadosModulo = () => {
    setModulo(undefined);
    setModuloPercentual(0);
    setModuloQtdAcessoIncluso(1);
    setAlterandoEdicaoModulo(false);
  };

  function excluirEdicaoModulo(rowData) {
    const idx = edicaoModulos.findIndex(e => e.idModulo === rowData.idModulo);

    if (idx >= 0) {
      edicaoModulos.splice(idx, 1);
    }
    setEdicaoModulos([...edicaoModulos]);
  }

  const footer = (
    <div>
      {!viewMode && (
        <Button
          label="Confirmar"
          icon="pi pi-check"
          disabled={!edicao}
          onClick={() => {
            if (handleConfirm) {
              const retorno = { ...sistemaEdicao, sistemaEdicaoModulo: edicaoModulos };
              retorno.edicao = { id: edicao.id, nome: edicao.nome };
              retorno.idEdicao = edicao.id;

              handleConfirm(retorno);
            }
          }}
          className="p-button-success"
        />
      )}

      <Button
        label="Cancelar"
        icon="pi pi-times"
        onClick={() => {
          if (handleClose) {
            handleClose();
          }
        }}
        className="p-button-danger"
      />
    </div>
  );

  return (
    <Container>
      <Dialog
        closable={false}
        footer={footer}
        header="Edição"
        visible={visible}
        style={{ minWidth: '350px', maxWidth: '800px', width: '95%' }}
        modal
        onHide={() => {
          if (handleClose) {
            handleClose();
          }
        }}
      >
        <div className="p-col-12 p-fluid" style={{ margin: 0, padding: 0 }}>
          <div className="p-grid" style={{ margin: 0, padding: 0 }}>
            <div className="p-col-12 p-md-6 p-lg-6 p-fluid">
              <LabelSp>Edição</LabelSp>
              <DropdownSp
                appendTo={document.body}
                options={edicoes}
                autoLoad
                placeholder="Selecione"
                required
                value={edicao}
                onChange={e => {
                  setEdicao(e.value);
                }}
                disabled={viewMode || modoEdicao}
              />
            </div>

            <div className="p-col-12 p-md-6 p-lg-6 p-fluid">
              <LabelSp>%Salário</LabelSp>
              <InputCurrencySp
                digits={3}
                style={{
                  textAlign: 'end',
                }}
                disabled={viewMode}
                placeholder=""
                value={sistemaEdicao.percSalario}
                onChange={(_e, v) => setSistemaEdicao({ ...sistemaEdicao, percSalario: v })}
              />
            </div>

            <div className="p-col-12 p-md-6 p-lg-6 p-fluid">
              <LabelSp>% Acesso Adici.</LabelSp>
              <InputCurrencySp
                digits={3}
                style={{
                  textAlign: 'end',
                }}
                disabled={viewMode}
                placeholder=""
                value={sistemaEdicao.percAcessoAdicional}
                onChange={(_e, v) =>
                  setSistemaEdicao({ ...sistemaEdicao, percAcessoAdicional: v })
                }
              />
            </div>
            <div className="p-col-12 p-md-6 p-lg-6 p-fluid">
              <LabelSp>Qt. Acessos Inclusos</LabelSp>
              <InputCurrencySp
                digits={0}
                style={{
                  textAlign: 'end',
                }}
                disabled={viewMode}
                placeholder=""
                value={sistemaEdicao.qtdAcessoIncluso}
                onChange={(_e, v) =>
                  setSistemaEdicao({ ...sistemaEdicao, qtdAcessoIncluso: v })
                }
              />
            </div>
            <div className="p-col-12 p-md-12 p-lg-12 p-fluid">
              <LabelSp>Dados dos Módulos</LabelSp>
              <hr />
            </div>
            <div className="p-col-12 p-md-6 p-lg-6 p-fluid">
              <LabelSp>Módulo</LabelSp>
              <DropdownSp
                filter
                disabled={alterandoEdicaoModulo || viewMode}
                appendTo={document.body}
                options={modulos}
                autoLoad
                placeholder="Selecione"
                value={modulo}
                onChange={e => {
                  setModulo(e.value);
                }}
              />
            </div>

            <div className="p-col-12 p-md-6 p-lg-6 p-fluid">
              <LabelSp>%Percentual</LabelSp>
              <InputCurrencySp
                digits={3}
                style={{
                  textAlign: 'end',
                }}
                disabled={viewMode}
                placeholder=""
                value={moduloPercentual}
                onChange={(_e, v) => setModuloPercentual(v)}
              />
            </div>
            <div className="p-col-12 p-md-6 p-lg-6 p-fluid">
              <LabelSp>Tipo Cobrança</LabelSp>
              <DropdownSp
                appendTo={document.body}
                options={[
                  { label: 'Fixo', value: 0 },
                  { label: 'Volume', value: 1 },
                ]}
                autoLoad
                placeholder="Selecione"
                value={moduloTipoCobranca}
                onChange={e => {
                  if (e.value === 0) {
                    setModuloQtdAcessoIncluso(1);
                  }
                  setModuloTipoCobranca(e.value);
                }}
                disabled={viewMode}
              />
            </div>
            <div className="p-col-12 p-md-4 p-lg-4 p-fluid">
              <LabelSp>Qtd. Incluso</LabelSp>
              <InputCurrencySp
                digits={0}
                style={{
                  textAlign: 'end',
                }}
                disabled={viewMode}
                placeholder=""
                value={moduloQtdAcessoIncluso}
                onChange={(_e, v) => setModuloQtdAcessoIncluso(v)}
              />
            </div>
            <div className="p-col-12 p-md-2 p-lg-2">
              <LabelSp className="label-button">&nbsp;</LabelSp>
              <Button
                label=""
                title="Confirmar módulo"
                icon="pi pi-check"
                disabled={viewMode || !modulo}
                onClick={() => {
                  inserirEdicaoModulo();
                }}
                className="p-button-primary"
              />
              <Button
                label=""
                title="Cancelar"
                icon="pi pi-times"
                disabled={viewMode}
                onClick={() => {
                  limparDadosModulo();
                }}
                className="p-button-warning"
              />
            </div>

            <div className="p-col-12 p-fluid">
              <DataTableSp value={edicaoModulos} style={{ marginBottom: '2px' }} responsive>
                <Column
                  className="grid-col"
                  header="Módulo"
                  body={rowData => rowData.modulo?.descricao}
                />
                <Column
                  className="grid-col grid-col-curr"
                  header="%Perc"
                  body={rowData => formatFloat(rowData.percentual, 3)}
                />
                <Column
                  className="grid-col grid-col-center"
                  style={{ width: 110 }}
                  header="Tipo Cob."
                  body={rowData => (rowData.tipoCobranca === 0 ? 'Fixo' : 'Volume')}
                />
                <Column
                  className="grid-col grid-col-center"
                  style={{ width: 110 }}
                  header="Qtd. Incluso."
                  body={rowData => rowData.qtdAcessoIncluso}
                />
                <Column
                  className="gid-col-acoes-35"
                  bodyStyle={{ textAlign: 'end' }}
                  body={viewMode ? null : renderButtonOpSocio}
                />
              </DataTableSp>
            </div>
          </div>
        </div>
      </Dialog>
    </Container>
  );

  function renderButtonOpSocio(rowData) {
    return (
      <BotaoMenuGrid
        handles={[
          () => {
            setModulo(rowData.modulo);
            setModuloPercentual(rowData.percentual);
            setModuloTipoCobranca(rowData.tipoCobranca);
            setModuloQtdAcessoIncluso(rowData.qtdAcessoIncluso);
            setAlterandoEdicaoModulo(true);
          },
          () => {
            excluirEdicaoModulo(rowData);
          },
        ]}
        labels={['Alterar', 'Excluir']}
        icons={['pi pi-pencil', 'pi pi-trash']}
      />
    );
  }
}
export default EdicaoSistema;
